import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

interface Props {
  text: string;
  className?: string;
}

/**
 * CharReveal — scroll-linked character opacity. As the user scrolls
 * past the paragraph, characters light up one by one from 0.28 → 1.
 */
export default function CharReveal({ text, className = '' }: Props) {
  const ref = useRef<HTMLSpanElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start 0.85', 'start 0.25'],
  });

  const chars = [...text];
  const total = chars.length;

  return (
    <span ref={ref} className={className}>
      {chars.map((ch, i) => {
        const charStart = total === 0 ? 0 : i / total;
        const charEnd = total === 0 ? 1 : Math.min(1, (i + 1) / total);
        const opacity = useTransform(scrollYProgress, [charStart, charEnd], [0.28, 1]);
        return (
          <motion.span key={i} style={{ opacity }}>
            {ch}
          </motion.span>
        );
      })}
    </span>
  );
}
